import imageCompression from 'browser-image-compression';
import { toast } from 'react-toastify';

export const compressedImage = async (event) => {
  const files = Array.from(event.target.files);
  const imageFiles = files.filter((file) => file.type.startsWith('image/'));

  if (imageFiles.length === 0) {
    toast.warning('Nenhuma imagem válida foi selecionada.');
    return null;
  }

  if (imageFiles.length !== files.length) {
    toast.warning('Alguns arquivos não são imagens ou você pode ter tentado selecionar uma pasta.');
    return null;
  }

  const options = {
    maxSizeMB: 0.8,
    maxWidthOrHeight: 2048,
    initialQuality: 0.85,
    useWebWorker: true,
    alwaysKeepResolution: true,
  };

  try {
    const compressedBlob = await imageCompression(imageFiles[0], options);

    return new File([compressedBlob], imageFiles[0].name, {
      type: imageFiles[0].type,
      lastModified: Date.now(),
    });

  } catch (error) {
    console.error('Erro ao comprimir imagem:', error);
    toast.error('Erro ao comprimir a imagem.');
    return null;
  }
};
